export default class {

    constructor (symbol, action) {
        this.symbol = symbol;
        this.action = action;
    }

    static randomCommands (size) {
        let commands = [
            new this('move1', robot => {robot.move(1)}),
            new this('move2', robot => {robot.move(2)}),
            new this('clockwise', robot => {robot.rotate()}),
            new this('anticlockwise', robot => {robot.rotate(false)}),
            new this('shoot', robot => {robot.shoot()}),
        ];
        let newCommands = []
		while (newCommands.length < size) {
			newCommands.push(commands[Math.floor(Math.random() * commands.length)]);
		}
		return newCommands;
    }
}
